import { render, staticRenderFns } from "./PrimaryNav.vue?vue&type=template&id=3718dbdb&scoped=true&"
import script from "./PrimaryNav.vue?vue&type=script&lang=js&"
export * from "./PrimaryNav.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryNav.vue?vue&type=style&index=0&id=3718dbdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3718dbdb",
  null
  
)

export default component.exports